import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { IMetadata } from '../../interfaces/metadata';
import type { TFindParams } from '../../server/services/metadata';
import { loadMetadata } from '../../services/metadata';
import type { GlobalState } from '../index';
import { getMetadata } from '../selectors/metadata';

export type IState = {
  data: Record<string, IMetadata>;
};

export const fetchMetadata = createAsyncThunk<
  { pathname: string; seo: IMetadata },
  TFindParams,
  {
    state: GlobalState;
  }
>(`metadata/fetchMetadata`, async (params, { getState }) => {
  const state = getState();

  let seo = getMetadata(params.url)(state);

  if (!seo) {
    seo = await loadMetadata(params);
  }

  return {
    pathname: params.url,
    seo,
  };
});

const metadataSlice = createSlice({
  name: 'metadata',
  initialState: { data: {} },
  reducers: {
    setMetadata: (state, { payload }: PayloadAction<{ pathname: string; seo: IMetadata }>) => {
      state.data[payload.pathname] = payload.seo;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMetadata.fulfilled, (state, { payload }) => {
      state.data[payload.pathname] = payload.seo;
    });
  },
});

const { actions, reducer } = metadataSlice;

export const { setMetadata } = actions;

export default reducer;
